import React from 'react';
import PropTypes from 'prop-types';
import SectionPagination from '../SectionPagination';
import ReactLoading from 'react-loading';
import LocalizedMessage from 'react-l10n';
import ProductListItem from './ProductListItem';
import ProductListItemSkeleton from './ProductListItemSkeleton';

class ProductList extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        const { request } = this.props;

        if (request) {
            request();
        }
    }
    getClassNames() {
        const { viewType, isLoading } = this.props;
        let classes = 'product-grid xs-2 sm-2 md-3 lg-3 xl-4';

        if (viewType == 'list') {
            classes += ' product-grid--list';
        }

        if (isLoading) {
            classes += ' product-grid--loading';
        }

        return classes;
    }
    renderEmpty() {
        return (
            <React.Fragment>
                <div className='product-grid__empty'>
                    <div className='text-box text-box--big text-box--grey'>
                        <p>
                            <LocalizedMessage id={'NO_PRODUCTS'} />
                        </p>
                    </div>
                </div>
            </React.Fragment>
        );
    }
    renderHasNotInitialized() {
        return (
            <React.Fragment>
                <div
                    className={this.getClassNames()}
                    style={{ position: 'relative' }}
                >
                    {[...Array(12)].map((item) => (
                        <ProductListItemSkeleton key={item} />
                    ))}
                </div>
            </React.Fragment>
        );
    }
    render() {
        const {
            hasInitialized,
            isLoading,
            list,
            activePage,
            totalPages,
            paginationPages,
            onPaginationClick,
            showNLISFilter,
            showNAITFilter,
            currencyFormat,
            currencyDisplayCode,
            locale,
        } = this.props;

        if (!hasInitialized) {
            return this.renderHasNotInitialized();
        }

        return (
            <React.Fragment>
                {!isLoading && list.length <= 0 ? (
                    this.renderEmpty()
                ) : (
                    <div
                        className={this.getClassNames()}
                        style={{ position: 'relative' }}
                    >
                        {isLoading === true && (
                            <ReactLoading
                                className='button__spinner'
                                type='spin'
                                color='black'
                                height={30}
                                width={30}
                                style={{ zIndex: 2 }}
                            />
                        )}
                        {list.map((item, key) => {
                            return (
                                <ProductListItem
                                    key={key}
                                    item={item}
                                    showNLISFilter={showNLISFilter}
                                    showNAITFilter={showNAITFilter}
                                    currencyFormat={currencyFormat}
                                    currencyDisplayCode={currencyDisplayCode}
                                    locale={locale}
                                />
                            );
                        })}
                    </div>
                )}

                {hasInitialized && (
                    <SectionPagination
                        activePage={activePage}
                        totalPages={totalPages}
                        pages={paginationPages}
                        onPaginationClick={(pageNum) =>
                            onPaginationClick(pageNum)
                        }
                    />
                )}
                
                

            </React.Fragment>
        );
    }
}

// default props
ProductList.defaultProps = {
    isLoading: false,
    list: [],
    viewType: 'grid',
    showNLISFilter: true,
    showNAITFilter: true,
};
// validate props
ProductList.propTypes = {
    isLoading: PropTypes.bool,
    list: PropTypes.array,
    viewType: PropTypes.string,
    showNLISFilter: PropTypes.bool,
    showNAITFilter: PropTypes.bool,
};

export default ProductList;
